<template>
  <div class="BookPage">
    <!-- <Navbar @Refrash="Refrash"/> -->
    <el-scrollbar :style="scrollbarStyle" wrap-class="scrollbar-wrapper">
      <seat v-show="IsShow" ref="Seat" @SeatSeled="SeatSeled" @CanselBook="CanselBook"/>
      <book-from v-show="!IsShow" :book-time="BookTime" @Book="Book" @GoBack="GoBack"/>
    </el-scrollbar>

    <mu-container>
      <mu-dialog :open.sync="ShowCanDia" title="取消预约" width="360">
        <mu-text-field v-model="Mobile" label="电话" full-width/>
        <mu-button slot="actions" flat color="primary" @click="CanHandle">确定</mu-button>
        <mu-button slot="actions" flat color="primary" @click="ShowCanDia = !ShowCanDia">取消</mu-button>
      </mu-dialog>
    </mu-container>

  </div>
</template>

<script>
import { Navbar, Seat, BookFrom } from './components/index'
import { BookSubmit, CanBook, GetWxUserInfo } from '@/api/all'
import Toast from 'muse-ui-toast'
import { getQueryString } from '../../utils/common'
export default {
  name: 'BookPage',
  components: { Navbar, Seat, BookFrom },
  data() {
    return {
      IsShow: true,
      SelItemList: [],
      BookTime: '',
      ShowCanDia: false,
      Mobile: '',
      CanMod: {},
      scrollbarStyle: {
        height: (window.innerHeight - 56) + 'px',
        width: '100%'
      }
    }
  },
  mounted() {
    var code = getQueryString('code')
    if (code) {
      const loading = this.$loading()
      GetWxUserInfo(code).then(res => {
        console.log(res)
        if (res.error !== 0) {
          loading.close()
          Toast.error(res.data.error)
        } else {
          Toast.success(res.msg)
          this.$store.dispatch('setWxToken', res.data.UserToken)
          this.$store.dispatch('setWxUserInfo', res.data)
          // console.log(this.$router)
          // console.log(this.$store.getters.beforerou)
          this.$router.replace({ path: '/Login' })
        }
        loading.close()
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch('setActiveBar', 'book')
    })
  },
  methods: {
    SeatSeled: function(SelItemList) {
      this.SelItemList = []
      this.BookTime = ''
      this.IsShow = false
      this.SelItemList = SelItemList

      this.BookTime = this.SelItemList[0].BookDate.split(' ')[0]
      if (this.SelItemList[0].TimeType === 1) {
        this.BookTime = this.BookTime + ' 上午 '
      } else if (this.SelItemList[0].TimeType === 2) {
        this.BookTime = this.BookTime + ' 下午 '
      }
      var StartTime = '23:59'
      for (var i = 0; i < this.SelItemList.length; i++) {
        if (this.FromateTime(StartTime) > this.FromateTime(this.SelItemList[i].StartTime)) {
          StartTime = this.SelItemList[i].StartTime
        }
      }

      var EndTime = '00:01'
      for (var j = 0; j < this.SelItemList.length; j++) {
        if (this.FromateTime(EndTime) < this.FromateTime(this.SelItemList[j].EndTime)) {
          EndTime = this.SelItemList[j].EndTime
        }
      }
      this.BookTime = this.BookTime + StartTime + '-' + EndTime
    },
    Book: function(BookInfo) {
      console.log(BookInfo)
      var BookMod = {
        BookTimeList: this.SelItemList,
        BookInfoMod: BookInfo
      }
      BookSubmit(BookMod).then(res => {
        console.log(res)
        if (res.error !== 0) {
          Toast.error(res.msg)
        } else {
          Toast.success(res.msg)
          this.IsShow = true
          this.$refs.Seat.GetTimeList()
        }
      })
    },
    GoBack: function() {
      this.IsShow = true
    },
    FromateTime: function(time) {
      var TimeStr = time.split(':')
      var TimeStr1 = TimeStr[0]
      var TimeStr2 = TimeStr[1]
      var NewTime = TimeStr1 + TimeStr2
      console.log(NewTime)
      return parseInt(NewTime)
    },
    Refrash: function() {
      this.IsShow = true
      this.$refs.Seat.GetTimeList()
      Toast.success('刷新成功！')
    },
    CanselBook: function(SelItem) {
      this.CanMod = {}
      this.CanMod = SelItem
      this.Mobile = ''
      this.ShowCanDia = true
    },
    CanHandle: function() {
      if (this.Mobile === this.CanMod.Mobile) {
        CanBook(this.CanMod).then(res => {
          if (res.error !== 0) {
            Toast.error(res.msg)
          } else {
            Toast.success(res.msg)
          }
          this.IsShow = true
          this.Mobile = ''
          this.ShowCanDia = false
          this.$refs.Seat.GetTimeList()
        })
      } else {
        Toast.error('不匹配！')
      }
    }
  }
}
</script>

<style scoped>
.BookPage{
  width: 100%;
  height: 100%;
}
.BookBtn{
  position: absolute;
  bottom: 5px;
  right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/BookPage/index.vue